import { Camera, Mic, ShieldCheck, X } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { withNode } from "@/lib/practiceLabels";

const Brand = () => <span dir="ltr" className="whitespace-nowrap">GetFluent<span className="text-coral">Loop</span></span>;

export default function ConsentGate({ type, open, onGrant, onClose }) {
  const { t } = useI18n();
  if (!open) return null;
  const isCam = type === "camera";
  const Icon = isCam ? Camera : Mic;
  const kind = isCam ? "Camera" : "Mic";

  const grant = async () => {
    try { await api.post("/consent", { consent_type: type, granted: true }); }
    catch (e) { console.warn("Consent log failed", e); }
    localStorage.setItem(`fluent_consent_${type}`, "granted");
    onGrant();
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-ink/60 backdrop-blur-sm" data-testid={`consent-gate-${type}`}>
      <div className="nb-card max-w-sm w-full p-6 animate-pop-in relative">
        <button onClick={onClose} className="absolute top-4 end-4" data-testid={`consent-close-${type}`} aria-label={t("pm.consent.close")}><X className="w-5 h-5" /></button>
        <div className={`w-14 h-14 rounded-2xl border-2 border-ink flex items-center justify-center ${isCam ? "bg-sky" : "bg-peach"}`}>
          <Icon className="w-7 h-7 stroke-[2.5]" />
        </div>
        <h3 className="font-cabinet font-bold text-xl mt-4">{t(`pm.consent.title${kind}`)}</h3>
        <p className="text-sm text-gray-600 mt-2" data-testid={`consent-body-${type}`}>
          {withNode(t(`pm.consent.needs${kind}`), "brand", <Brand />)}
        </p>
        <div className="flex items-start gap-2 mt-4 bg-mint/40 border-2 border-ink rounded-xl p-3">
          <ShieldCheck className="w-5 h-5 shrink-0 mt-0.5" />
          <p className="text-xs font-medium">
            {withNode(t(`pm.consent.raw${kind}`), "del", <strong>{t(`pm.consent.deleted${kind}`)}</strong>)}
          </p>
        </div>
        <button onClick={grant} data-testid={`consent-grant-${type}`} className="nb-btn-primary w-full mt-5 py-3">
          {t("pm.consent.grant")}
        </button>
        <button onClick={onClose} className="w-full mt-2 text-sm text-gray-500 py-2" data-testid={`consent-not-now-${type}`}>{t("pm.consent.notNow")}</button>
      </div>
    </div>
  );
}
